export * from './location/platform_location';
export * from './location/location_strategy';
export * from './location/hash_location_strategy';
export * from './location/path_location_strategy';
export * from './location/location';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
